var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition",
        {
          attrs: { mode: "out-in", name: "vue-lb-content-transition" },
          on: {
            afterEnter: _vm.enableImageTransition,
            beforeLeave: _vm.disableImageTransition,
          },
        },
        [
          _vm.media
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lightBoxOn,
                      expression: "lightBoxOn",
                    },
                  ],
                  ref: "container",
                  staticClass: "vue-lb-container",
                },
                [
                  _c("div", { staticClass: "vue-lb-content" }, [
                    _c("div", { staticClass: "vue-lb-header" }, [
                      _c("span"),
                      !_vm.editMode &&
                      _vm.media[_vm.select] &&
                      _vm.media[_vm.select].type !== "video" &&
                      false
                        ? _c(
                            "button",
                            {
                              staticClass: "vue-lb-button-close",
                              attrs: { type: "button", title: _vm.closeText },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm._onEditClicked(
                                    _vm.media[_vm.select].src
                                  )
                                },
                              },
                            },
                            [_c("EditIcon")],
                            1
                          )
                        : _vm._e(),
                      _vm.editMode
                        ? _c(
                            "button",
                            {
                              staticClass: "vue-lb-button-close",
                              attrs: { type: "button", title: _vm.closeText },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm._onRectClicked.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_c("RectangleIcon")],
                            1
                          )
                        : _vm._e(),
                      _vm.editMode
                        ? _c(
                            "button",
                            {
                              staticClass: "vue-lb-button-close",
                              attrs: { type: "button", title: _vm.closeText },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm._onCircleClicked.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_c("CircleIcon")],
                            1
                          )
                        : _vm._e(),
                      _vm.editMode
                        ? _c(
                            "button",
                            {
                              staticClass: "vue-lb-button-close",
                              attrs: { type: "button", title: _vm.closeText },
                            },
                            [_c("TextIcon")],
                            1
                          )
                        : _vm._e(),
                      _vm.editMode
                        ? _c(
                            "button",
                            {
                              staticClass: "vue-lb-button-close",
                              attrs: { type: "button", title: _vm.closeText },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm._onSaveClicked.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_c("SaveIcon")],
                            1
                          )
                        : _vm._e(),
                      _vm.closable
                        ? _c(
                            "button",
                            {
                              staticClass: "vue-lb-button-close",
                              attrs: { type: "button", title: _vm.closeText },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.closeLightBox.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._t("close", function () {
                                return [_c("CloseIcon")]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                    !_vm.editMode
                      ? _c(
                          "div",
                          {
                            staticClass: "vue-lb-figure",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c(
                              "transition",
                              {
                                attrs: {
                                  mode: "out-in",
                                  name: _vm.modalImageTransitionName,
                                },
                              },
                              [
                                _vm.media[_vm.select] &&
                                _vm.media[_vm.select].type !== "video"
                                  ? _c("img", {
                                      directives: [
                                        {
                                          name: "lazy",
                                          rawName: "v-lazy",
                                          value: {
                                            src: _vm.media[_vm.select].src,
                                            loading: _vm.media[_vm.select].src,
                                            error: _vm.media[_vm.select].src,
                                          },
                                          expression:
                                            "{\n                src: media[select].src,\n                loading: media[select].src,\n                error: media[select].src,\n              }",
                                        },
                                      ],
                                      key: _vm.media[_vm.select].src,
                                      staticClass: "vue-lb-modal-image",
                                      attrs: {
                                        srcset:
                                          _vm.media[_vm.select].srcset || "",
                                        alt: _vm.media[_vm.select].caption,
                                      },
                                    })
                                  : _c(
                                      "video",
                                      {
                                        key: _vm.media[_vm.select].sources[0]
                                          .src,
                                        ref: "video",
                                        attrs: {
                                          width: _vm.media[_vm.select].width,
                                          height: _vm.media[_vm.select].height,
                                          autoplay:
                                            _vm.media[_vm.select].autoplay,
                                          controls: "",
                                        },
                                      },
                                      _vm._l(
                                        _vm.media[_vm.select].sources,
                                        function (source) {
                                          return _c("source", {
                                            key: source.src,
                                            attrs: {
                                              src: source.src,
                                              type: source.type,
                                            },
                                          })
                                        }
                                      ),
                                      0
                                    ),
                              ]
                            ),
                            _vm._t("customCaption", function () {
                              return [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showCaption,
                                      expression: "showCaption",
                                    },
                                  ],
                                  staticClass: "vue-lb-info",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.media[_vm.select].caption
                                    ),
                                  },
                                }),
                              ]
                            }),
                            _c("div", { staticClass: "vue-lb-footer" }, [
                              _c("div", { staticClass: "vue-lb-footer-info" }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showFooterCount,
                                      expression: "showFooterCount",
                                    },
                                  ],
                                  staticClass: "vue-lb-footer-count",
                                },
                                [
                                  _vm._t(
                                    "footer",
                                    function () {
                                      return [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.select + 1) +
                                            " / " +
                                            _vm._s(_vm.media.length) +
                                            "\n              "
                                        ),
                                      ]
                                    },
                                    {
                                      current: _vm.select + 1,
                                      total: _vm.media.length,
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editMode,
                            expression: "editMode",
                          },
                        ],
                        staticStyle: {
                          "max-width": "100vw",
                          "max-height": "90vh",
                          overflow: "scroll",
                        },
                      },
                      [_c("canvas", { ref: "can", attrs: { id: "c" } })]
                    ),
                  ]),
                  _c("div", { staticClass: "vue-lb-thumbnail-wrapper" }, [
                    _vm.showThumbs && !_vm.editMode
                      ? _c(
                          "div",
                          { staticClass: "vue-lb-thumbnail" },
                          [
                            _vm.media.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "vue-lb-thumbnail-arrow vue-lb-thumbnail-left",
                                    attrs: {
                                      type: "button",
                                      title: _vm.previousThumbText,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.previousImage()
                                      },
                                    },
                                  },
                                  [
                                    _vm._t("previousThumb", function () {
                                      return [_c("LeftArrowIcon")]
                                    }),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._l(_vm.imagesThumb, function (image, index) {
                              return _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        index >= _vm.thumbIndex.begin &&
                                        index <= _vm.thumbIndex.end,
                                      expression:
                                        "index >= thumbIndex.begin && index <= thumbIndex.end",
                                    },
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy:background-image",
                                      value: image,
                                      expression: "image",
                                      arg: "background-image",
                                    },
                                  ],
                                  key:
                                    typeof image.src === "string"
                                      ? `${image.src}${index}`
                                      : index,
                                  class:
                                    "vue-lb-modal-thumbnail" +
                                    (_vm.select === index ? "-active" : ""),
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.showImage(index)
                                    },
                                  },
                                },
                                [
                                  image.type
                                    ? _vm._t("videoIcon", function () {
                                        return [_c("VideoIcon")]
                                      })
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                            _vm.media.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "vue-lb-thumbnail-arrow vue-lb-thumbnail-right",
                                    attrs: {
                                      type: "button",
                                      title: _vm.nextThumbText,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.nextImage()
                                      },
                                    },
                                  },
                                  [
                                    _vm._t("nextThumb", function () {
                                      return [_c("RightArrowIcon")]
                                    }),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                  _vm.media.length > 1 && !_vm.editMode
                    ? _c(
                        "button",
                        {
                          staticClass: "vue-lb-arrow vue-lb-left",
                          attrs: { type: "button", title: _vm.previousText },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.previousImage()
                            },
                          },
                        },
                        [
                          _vm._t("previous", function () {
                            return [_c("LeftArrowIcon")]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.media.length > 1 && !_vm.editMode
                    ? _c(
                        "button",
                        {
                          staticClass: "vue-lb-arrow vue-lb-right",
                          attrs: { type: "button", title: _vm.nextText },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.nextImage()
                            },
                          },
                        },
                        [
                          _vm._t("next", function () {
                            return [_c("RightArrowIcon")]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }